
export const replace = (el, bindding) => {
  const reg = new RegExp(bindding.value.replaceText, "g")
  el.innerHTML = el.innerHTML.replace(reg, bindding.value.replaceContent)
}